import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import {
  FaArrowRight, FaLandmark, FaHospital, FaCloud, FaStore, FaUniversity,
} from 'react-icons/fa';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import ScrollReveal from './ScrollReveal';
import { staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import { industries } from '../config/industriesConfig';
import './ContentPages.css';

const iconMap = {
  landmark: <FaLandmark />,
  hospital: <FaHospital />,
  cloud: <FaCloud />,
  store: <FaStore />,
  university: <FaUniversity />,
};

const IndustriesPage = () => (
  <div className="content-page">
    <PageNavbar />

    <section className="content-hero">
      <div className="content-hero-background" />
      <div className="content-hero-stars" />
      <ScrollReveal className="content-hero-inner" animateOnMount variant="fadeUp">
        <span className="content-badge">Industries</span>
        <h1 className="content-hero-title">
          Tailored Security Across <span className="content-accent">Every Sector.</span>
        </h1>
        <p className="content-hero-desc">
          The right control set for a hospital group looks nothing like the right control set for
          a lending platform. We scope every engagement around what your industry actually needs.
        </p>
      </ScrollReveal>
    </section>

    <section className="content-section alt">
      <div className="content-container">
        <motion.div
          className="content-grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          {industries.map((ind) => (
            <motion.div key={ind.slug} className="content-card" variants={staggerItem}>
              <div className="content-card-icon">{iconMap[ind.icon]}</div>
              <h3 className="content-card-title">{ind.label}</h3>
              <p className="content-card-desc">{ind.heroDesc}</p>
              <Link to={`/industries/${ind.slug}`} className="content-card-link">
                Explore {ind.label} <FaArrowRight />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>

    <Footer />
  </div>
);

export default IndustriesPage;
